module.exports = __webpack_public_path__ + "static/img/kaishu_benefit_detail2.54256a54.jpg";